import React, { Component } from 'react';


// Styles
import './app.css';


// Components
import Routes from './routes';


class App extends Component {
    render() {
        return (
            <Routes />
        );
    }
}

export default App;